import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import { required, minValue } from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import axios from 'axios';
import store from '../../store';
import CONFIG from "@/assets/js/config.js";
import ValidationService from '@/services/ValidationService';

export default {
  name: "attendanceTeacherList",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading,
  },

  mixins: [ValidationService],

  data() {
    return {
      isLoading: false,
      submitted: false,
      disabled: false,
      isSearch: false,
      searchDisabled: false,
      dateError: "",
      teacherArr: [
        {id: 0, text: "Select Teacher"}
      ],
      searchData: {
        teacherId: 0,
        startDate: "",
        endDate: "",
      },
      attendanceList: [],
      deletedIds: [],
      total: 0,
      emptyData: CONFIG.FORM_REQUEST_MESSAGE,
      configDateTime: {
        allowInput: true,
        enableTime: true,
        timeFormat: "h:i K", 
        noCalendar: true, 
        time_24hr: false,
        enableSeconds: false,
        altInput: true,
      },
      attendanceError: [],
    };
  },

  validations: {
    searchData: {
      teacherId: {
        required,
        minValue: minValue(1)
      },
      startDate: {
        required
      },
      endDate: {
        required
      },
    }
  },

  computed: {
    validDates() {
      const startDate = this.searchData.startDate;
      const endDate = this.searchData.endDate;

      if (!startDate || !endDate) {
        return false;
      }

      const start = new Date(startDate);
      const end = new Date(endDate);

      if (end < start) {
        this.dateError = 'End date must be equal or after start date';
        return false;
      }

      const diffTime = end - start;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

      if (diffDays > 31) {
        this.dateError = 'Date range cannot exceed 31 days';
        return false;
      }

      return true;
    }
  },

  methods: {
    getTeacherNameList() {
      axios.get("/teacher/getallTeacher", {params: {campus_id: store.state.user.campus_id}})
        .then((response) => {
          if(response.data[0].length > 0) {
            this.teacherArr = this.teacherArr.concat(response.data[0]);
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        })
        .finally(() => this.isLoading = false);
    },

    getAttendanceList() {
      this.searchDisabled = true;
      this.isLoading = true;
      this.isSearch = true;

      if (this.$v.$invalid || !this.validDates) {
        this.searchDisabled = false;
        this.isLoading = false;
        return;
      }

      this.attendanceList = [];
      this.deletedIds = [];

      const request = {
        start_date: this.searchData.startDate,
        end_date: this.searchData.endDate
      };
      axios.get("/teacher-attendance/" + this.searchData.teacherId, {params: request})
        .then(res => {
          const attendances = res.data;
          this.total = attendances.length;
          this.attendanceList = this.extractAttandanceData(attendances, CONFIG.SHIFT_LIMIT);
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.log("Teacher Attendance Search API Error", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isSearch = false;
          this.searchDisabled = false;
          this.disabled = Boolean(!this.total);
          this.emptyData = CONFIG.NO_SHIFT_DATA;
        });
    },

    extractAttandanceData(attendances, limit) {
      if (!attendances.length) {
        return [];
      }

      return attendances.map((attendance) => {
        const result = [];
        let rowSpans = 0;

        for (let i = 1; i <= limit; i ++) {
          if (!attendance[`has_shift${i}`]) {
            continue;
          }

          const data = {
            shiftSection: i,
            id: attendance.id,
            arrival: attendance[`actual_arrival_time${i}`],
            dept:  attendance[`actual_dept_time${i}`]
          }

          if (!result.length) {
            data["isRow"] = true;
            data["date"] = attendance.date;
            data["remark"] = attendance.remark;
          } 

          result.push(data)
          rowSpans ++;
        }
        result[0].rowSpans = rowSpans;

        return result;
      }).flat();
    },

    compressAttandanceData(attendances) {
      let list = [];
      const padSec = (time) => time.split(":").length < 3 ? time + ":00" : time;

      for (let i = 0;i < attendances.length; i ++) {
        const item = attendances[i];

        if (this.deletedIds.includes(item.id)) continue;

        const startTime = item.arrival ? padSec(item.arrival) : null;
        const endTime = item.dept ? padSec(item.dept) : null;

        if (item.isRow) {
          const attendance = {
            id: item.id,
            remark: item.remark
          };

          attendance.shiftSection = item.shiftSection;
          attendance[`actual_arrival_time${item.shiftSection}`] = startTime;
          attendance[`actual_dept_time${item.shiftSection}`] = endTime;
          list.push(attendance);
        } else {
          list[list.length - 1].shiftSection = item.shiftSection;
          list[list.length - 1][`actual_arrival_time${item.shiftSection}`] = startTime;
          list[list.length - 1][`actual_dept_time${item.shiftSection}`] = endTime;
        }
      }

      return list;
    },

    register() {
      this.submitted = true;
      this.disabled = true;
      this.validationErrors = {};
      this.attendanceError = [];
      let attendanceArr = this.compressAttandanceData(this.attendanceList);

      axios.patch("/teacher-attendance/register/", {
        attendances: attendanceArr
      })
      .then(() => {
        this.$notification.success("Attendance for Teacher Added Successfully", {
          timer: 3,
          position: "bottomCenter",
        });
        this.showList();
      })
      .catch(error => {
        if (error.response && error.response.status === 422) {
          this.validationErrors = error.response.data.errors;
          this.getDateErrorMessage(attendanceArr);
          if (this.attendanceList.length === 0) {
            this.$notification.error("Please search attendance data first.", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        } else if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          this.printValidationError(error.response);
        }

        this.isLoading = false;
        this.disabled = false;
        console.log("Attendance for Teacher Create API Error", error.errors);
      });
    },

    showList() {
      this.$router.push({
        path: "/attendanceTeacher/list"
      });
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deletedIds.push(id);
        this.total = this.total - 1;
        this.disabled = Boolean(!this.total);
      }
    },

    getDateErrorMessage(attendanceArr) {
      Object.entries(this.validationErrors)
        .filter(([key]) => /^attendances\.\d+\.actual_(arrival|dept)_time\d*$/.test(key))
        .forEach(([key, messages]) => {
          const fitltersMsgs = messages.filter(msg => !msg.includes("attendances"));
          const [, index, field] = key.split('.');
          const attendance = attendanceArr?.[Number(index)];
          if (!attendance) return;

          const shift = Number((field.match(/\d+$/) || [0])[0]);
          const type = key.includes("arrival") ? "arrival" : "dept";

          this.attendanceError[attendance.id] = this.attendanceError[attendance.id] || [];
          this.attendanceError[attendance.id][shift] = this.attendanceError[attendance.id][shift] || {};
          this.attendanceError[attendance.id][shift][type] = fitltersMsgs[0];
        });
    },

    printDateErrorMessage(id, shift, type) {
      try {
        const message = this.attendanceError[id][shift][type];
        return message;
      } catch (err) {
        return false;
      }
    }
  },

  mounted() {
    this.isLoading = true;
    this.getTeacherNameList();
  },
};
